import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import FalconComponentCard from "components/common/FalconComponentCard";
import MultiSelect from "components/common/MultiSelect";
import React from "react";
import { Col, Form, InputGroup, Row } from "react-bootstrap";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";

const FrequencyMedicalHistory = ({ setValue, watch, control }) => {
  const { viewModal, durationList } = useSelector(
    (state) => state.preauthorization
  );
  const { viewModal: claimView } = useSelector((state) => state.claim);

  // Watch frequency and frequencyType
  const frequency = watch("frequency");
  const frequencyType = watch("frequencyType");
  const period = watch("period");

  // Make Period required if either frequency or frequencyType is selected
  const isPeriodRequired = !!frequency || !!frequencyType;

  return (
    <Col xs={12} sm={12} md={4}>
      <FalconComponentCard className="custom-card">
        <FalconComponentCard.Body className="custom-body">
          <Row>
            <Col xs={12} sm={6} xl={4}>
              <TextInput
                name="frequency"
                label="Frequency"
                size="sm"
                disabled={viewModal || claimView}
                type="number"
                min={0}
                control={control}
              />
            </Col>
            <Col xs={12} sm={12} xl={8}>
              <Form.Group>
                <Form.Label>
                  Period{" "}
                  {isPeriodRequired && <span className="text-danger">*</span>}
                </Form.Label>
                <InputGroup>
                  {/* Period field */}
                  <Controller
                    name="period_info"
                    control={control}
                    disabled={viewModal || claimView}
                    rules={{
                      required: isPeriodRequired,
                    }}
                    render={({ field }) => (
                      <Form.Control
                        {...field}
                        type="number"
                        min={0}
                        placeholder="Period"
                        size="sm"
                      />
                    )}
                  />

                  {/* Frequency Type field */}
                  <Controller
                    name="frequencyType"
                    control={control}
                    disabled={viewModal || claimView}
                    rules={{
                      required: !!period,
                    }}
                    render={({ field }) => (
                      <Form.Select {...field} className="form-select" size="sm">
                        <option value="">Select</option>
                        {durationList.map((opt) => (
                          <option
                            key={opt.ucumtype_code}
                            value={opt.ucumtype_code}
                          >
                            {opt.ucumtype_name}
                          </option>
                        ))}
                      </Form.Select>
                    )}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
          </Row>
        </FalconComponentCard.Body>
      </FalconComponentCard>
    </Col>
  );
};

export default FrequencyMedicalHistory;
